import {ReactNode} from "react"
import {RootState} from "../../rootReducer"
import {useAppSelector} from "../../store"

export const PermissionsChecker = (props: {
    children: Array<ReactNode> | ReactNode
    permission: string[]
}): JSX.Element =>
    hasPermission(
        props.permission,
        useAppSelector((state: RootState) => state.application.permissions),
    ) ? (
        <>{props.children}</>
    ) : (
        <></>
    )

export const hasPermission = (checkPermission: string[], assignedPermissions: any) =>
    assignedPermissions.permissions.some((Checkvalue: any) =>
        checkPermission.some((sentvalue: any) => sentvalue === Checkvalue),
    )
